import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const WebDevelopmentJobsFbd = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Web Development Jobs in Faridabad | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Explore the latest Web Development Jobs in Faridabad . Find openings for Frontend, Backend, and Full Stack Web Developers. Apply now at JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="web development jobs in Faridabad, frontend developer jobs Faridabad, backend developer jobs Faridabad, full stack web developer jobs Faridabad, HTML CSS JavaScript jobs Faridabad, React developer jobs Faridabad, Node.js developer jobs Faridabad, web designer jobs Faridabad NCR, fresher web developer jobs Faridabad, web developer openings Faridabad"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/webdevelopment-jobs-in-faridabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Web Development Jobs in Faridabad – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>Web Development Jobs in Faridabad NCR</strong>? Whether you're a frontend, backend, or full stack web developer, explore verified opportunities across top companies and startups hiring in Faridabad NCR.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Web Developers in Faridabad
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Accenture</li>
          <li>Wipro</li>
          <li>Infosys</li>
          <li>HCL</li>
          <li>Tech Mahindra</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Web Developer Roles in Faridabad
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Frontend Developer Jobs in Faridabad</li>
          <li>Backend Developer Jobs in Faridabad</li>
          <li>Full Stack Developer Jobs in Faridabad</li>
          <li>React Developer Jobs in Faridabad</li>
          <li>Node.js Developer Jobs in Faridabad</li>
          <li>PHP Developer Jobs in Faridabad</li>
          <li>JavaScript Developer Jobs in Faridabad</li>
          <li>Web Designer Jobs in Faridabad</li>
          <li>HTML/CSS Developer Jobs in Faridabad</li>
          <li>WordPress Developer Jobs in Faridabad</li>
        </ul>

        <p className="text-gray-600">
          Kickstart your career with <strong>jobsindelhincr.in</strong> — your trusted job portal to find verified <strong>Web Development Jobs in Faridabad  </strong>. No registration required – apply directly and start working with the best companies today.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default WebDevelopmentJobsFbd;
